import { createSlice, PayloadAction } from '@reduxjs/toolkit';


interface Transaction {
  availableBalance:number
  }
  interface TotalFundData {
    fundId: number;
    fundName: string;
    fundType:string;
    description: string;
    isActive:string;
    fundTransactionHistory:Transaction[]
  }
interface ParticipantState {
  
  participantName: string;
  participantId:  number| string | undefined;
  participantsArray:any[]
  funds:TotalFundData[]
  
}

  
const initialState: ParticipantState = {
  participantName: "",
  participantId: 0,
  participantsArray:[],
  funds:[],
 
};

const participantsSlice = createSlice({
  name: 'participants',
  initialState,
  reducers: {
    setParticipantDetails: (state, action: PayloadAction<Partial<ParticipantState>>) => {
      return { ...state, ...action.payload };
    },
    resetSwitchParticipant: () => initialState,

  },
  
});

export const { setParticipantDetails,resetSwitchParticipant } = participantsSlice.actions;
export default participantsSlice.reducer;
